<template>
  <main class="main-section-content">
    <section class="main-section">
      <article class="main-section__content">
        <div class="primary-color sign-up-title">
          {{ $t('signupHeader', 'Start Your Free Trial.') }}
        </div>
        <sign-up-form @submit="handleSubmit">
          <template #submit-button="{submit}">
            <main-button
              :text="$t('continue', 'Continue')"
              depressed
              @click="submit"
            />
          </template>
          <sign-up-container />
        </sign-up-form>
        <div class="no-account-text-container">
          <div class="spacer" />
          <div class="no-account-text">Already have an account?</div>
          <div class="spacer" />
        </div>
        <div class="button-holder">
          <main-button
            :text="$t('logIn', 'Log in')"
            depressed
            @click="goTo(routes.shared.login, { redirectUrl })"
          />
        </div>
      </article>
      <figure class="main-section__figure">
        <img src="../../assets/demo.jpg" alt="login-image">
      </figure>
    </section>
    <simple-snackbar v-bind.sync="snackbar" />
  </main>
</template>

<script>
import SignUpForm from './sign-up-form'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import { signUp } from '../../http'

export default {
  name: 'sign-up-container',
  components: {
    SignUpForm,
    SimpleSnackbar,
  },
  props: {
    redirectUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      snackbar: {
        open: false,
        messageProp: '',
        color: 'primary',
      },
    }
  },
  methods: {
    async handleSubmit(formData) {
      const { errors } = await signUp(
        formData,
        this.redirectUrl && this.redirectUrl.includes('accept-invite')
          ? this.redirectUrl.split('/accept-invite/')[1]
          : null,
      )

      if (errors) {
        this.snackbar = {
          messageProp: errors[0].message,
          color: 'error',
          open: true,
        }
      } else if (this.redirectUrl) {
        window.location.replace(this.redirectUrl)
      } else {
        this.goTo(this.routes.shared.successfulSignUp)
      }
    },
  },
}
</script>

<style scoped>
.main-section-content {
  display: grid;
  grid-auto-rows: auto;
  gap: 13.125rem;
  margin-bottom: 13.125rem;
}

.main-section__figure {
  height: 100%;
}

img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 1.75rem;
}

.main-section {
  max-width: 1216px;
  padding: 0 2.625rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 662px 1fr;
  gap: 2.625rem;
  align-items: center;
}

.sign-up-title {
  font-family: Raleway, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  letter-spacing: -0.03em;
  align-self: center;
  margin-bottom: 24px;
  text-align: center;
}

.main-section__content {
  margin: 2.625rem 0;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 730px) {
  .sign-up-title {
    font-size: 3.938rem;
  }

  .main-section {
    grid-template-columns: 1fr;
    margin: 0;
    padding: 0;
  }

  .main-section__figure {
    display: none;
  }
}
@media screen and (max-width: 730px) {
  .sign-up-title {
    font-size: 3.938rem;
  }
  .main-section {
    grid-template-columns: 1fr;
    margin: 0;
    padding: 0;
  }
  .main-section__figure {
    display: none;
  }
}

.no-account-text-container {
  display: flex;
  align-items: center;
  max-width: 500px;
  align-self: center;
  width: 100%;
  margin-top: 3rem;
}
.spacer {
  flex: 1;
  border: 0.5px solid rgba(151, 151, 151, 0.5);
}
.no-account-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  text-align: center;
  color: #333333;
  margin-right: 1rem;
  margin-left: 1rem;
}
.button-holder {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
}
</style>
